// extracted by mini-css-extract-plugin
export var avatar = "_q9-3";
export var avatarContainer = "_q9-2";
export var avatarSpacer = "_q9-5";
export var avatarSpacerContainer = "_q9-4";
export var avatarStackContainer = "_q9-1";
export var bubble = "_q9-0";
export var remainderBubble = "_q9-6";